import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { grey } from '@mui/material/colors';
import './accordion.css';

export default function AccordionSection({ title , description }) {
  return (
    <div className='accordion-area'>
        <Accordion className="accordion">
          <AccordionSummary
              expandIcon={<ArrowDropDownIcon sx={{ color: grey [50] }} />}
              className="accordionSummary"
              aria-controls="panel1-content"
              id="panel1-header">
              <h3 className='f--size-20 w_color'>{title}</h3>
          </AccordionSummary>
          <AccordionDetails className='accordionDetails'>
              <p>{description}</p>
          </AccordionDetails>
        </Accordion>
    </div>
  )
}

